module.exports = __webpack_public_path__ + "static/media/sad-logo.6713fb2e.png";